import { PAYMENT_PROGRAM_ACTIONS } from "constants/actions";

export function fetchPaymentProgramDetails(requestType, page, page_size, filters) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FETCH_PAYMENT_PROGRAM_DETAILS,
        payload: {
            requestType: requestType,
            page,
            page_size,
            filters
        }
    };
}

export function fetchedPaymentProgramDetails(requestType, page, page_size, data) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FETCHED_PAYMENT_PROGRAM_DETAILS,
        payload: {
            requestType: requestType,
            page,
            page_size,
            data: data
        }
    };
}

export function failedFetchPaymentProgramDetails(requestType, page, page_size, error) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FAILED_FETCH_PAYMENT_PROGRAM_DETAILS,
        payload: {
            requestType: requestType,
            page,
            page_size
        },
        error: error
    };
}


export function updateUserDocumentDetails(company_id , document_id , data) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.UPDATE_USER_DOCUMENT_DETAILS,
        payload: {
            company_id ,
            document_id , 
            data
        }
    };
}

export function updatedUserDocumentDetails(data) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.UPDATED_USER_DOCUMENT_DETAILS,
        payload: {
            data
        }
    };
}

export function failedUpdateUserDocumentDetails(error) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FAILED_UPDATE_USER_DOCUMENT_DETAILS,
        error: error
    };
}


export function fetchUpdateChecklistJson(case_id) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FETCH_UPDATE_CHECKLIST_JSON,
        payload: {
            case_id
        }
    };
}

export function fetchUpdatedChecklistJson(data) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FETCH_UPDATED_CHECKLIST_JSON,
        payload: {
            data
        }
    };
}

export function failedFetchUpdateChecklistJson(error) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FAILED_FETCH_UPDATE_CHECKLIST_JSON,
        error: error
    };
}


export function fetchUpdateEntityDocuments(company_id , action_detail_id , data , callAPi) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FETCH_UPDATE_ENTITY_DOCUMENTS,
        payload: {
            company_id,
            action_detail_id,
            data,
            callAPi
        }
    };
}

export function fetchedUpdateEntityDocuments(data) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FETCHED_UPDATE_ENTITY_DOCUMENTS,
        payload: {
            data
        }
    };
}

export function failedUpdateEntityDocuments(error) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FAILED_UPDATE_ENTITY_DOCUMENTS,
        error: error
    };
}


//payment program inside details
export function fetchPaymentProgramActionDetails(case_id , onboarding_id) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FETCH_PAYMENT_PROGRAM_ACTION_DETAILS,
        payload: {
            case_id,
            onboarding_id
        }
    };
}

export function fetchedPaymentProgramActionDetails(data , case_id ) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FETCHED_PAYMENT_PROGRAM_ACTION_DETAILS,
        payload: {
            data: data,
            case_id
        }
    };
}

export function failedFetchPaymentProgramActionDetails(error) {
    return {
        type: PAYMENT_PROGRAM_ACTIONS.FAILED_FETCH_PAYMENT_PROGRAM_ACTION_DETAILS,
        error: error
    };
}